import React from 'react';
import styled from 'styled-components';

import { SUPPORT_EMAIL } from 'utils';
import { Text, Link } from 'components';
import { StyledBodyPane } from './StyledComponents';

const AppointmentDeskError: React.FC = () => (
    <StyledBodyPane>
      <Text>
        It looks like something went wrong connecting you to the Appointment
        Desk screen. Please contact our Customer Success team at{' '}
        <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link> with your
        brokerage information.
      </Text>
    </StyledBodyPane>
  );

export default AppointmentDeskError;
